import React from "react";
import { HiOutlineInformationCircle } from "react-icons/hi";

const DataAsOfNotice = ({ 
  message = null 
}) => {
  return (
    <div className={`mt-4 flex items-center text-[11px] text-gray-400 font-medium ${message ? 'justify-between' : 'justify-end'}`}>
      {message && (
        <div className="flex items-center gap-1.5">
          <HiOutlineInformationCircle className="text-lg shrink-0" />
          <span>{message}</span>
        </div>
      )}
      <div className={`flex items-center gap-1.5 shrink-0 ${message ? 'ml-4' : ''}`}>
        <span>
          Data as of{" "}
          {new Date().toLocaleString("en-US", {
            timeZone: "America/New_York",
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          })}
        </span>
      </div>
    </div>
  );
};

export default DataAsOfNotice;
